<template>
    <div>
        <main class="main-content">
            <div class="page-content">
          <div class="container">
            <div class="page-links">
				<router-link to="/safari/calculation" class="page-links__item">Calculation Setting</router-link>
                <router-link to="/safari/parks" class="page-links__item is-active">National Parks</router-link>
			</div>
			<div class="lds-ring" v-if="!isLoad"><div></div><div></div><div></div><div></div></div>
            <section class="np-detail" v-if="isLoad">
              <div class="page-title">
                <h2>Safari | National Parks</h2>
              </div>
              <div class="section-title">
				<h3>{{isEdit ? 'Edit Park' : 'Add Park'}}</h3><a @click="$router.back()" href="javascript:void(0)" class="btn btn--back">
				<div class="btn--back__icon">
					<svg width="1em" height="1em" class="icon icon-collapse ">
						<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
					</svg>
				</div><span>Back</span></a>
              </div>
              <form action="javascript:void(0)" class="np-detail-form">
                <div class="np-detail-section">
                  <div class="np-detail-section__title"><span>1. Info</span></div>
                  <div class="np-detail-country">
                    <div class="form-control-group">
                      <span class="form-control-label">Country</span>
                      <div
                        :class="[
                          'select-wrapper',
                          {'is-active': selects.country},
                          {'is-error': errors.country},
                        ]"
                        @click="
                          changeSelects('country')
                          errors.country = false
                        ">
                        <div class="select-trigger">
                          <span class="select-trigger__name">{{
                            countries.find(item => item.id === countryId)
                              ? countries.find(item => item.id === countryId).name
                              : 'Choose'
                          }}</span>
                          <span class="select-trigger__icon">
                            <svg width="1em" height="1em" class="icon icon-chevron">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                            </svg>
                          </span>
                        </div>
                        <div class="select-body">
                          <div class="select-inner">
                            <div
                              v-for="country in countries"
                              :key="country.id"
                              :class="[
                                'select-option',
                                {'is-selected': country.id === countryId},
                              ]"
                              @click="
                                countryId = country.id
                                isEditFlag = true
                              ">
                              <span class="select-option__name">{{ country.name }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-for="item in info"
                    :key="item.title"
                    :class="['np-detail-collapse', 'js-collapse', { 'is-collapsed' : item.collapse }]">
                    <div class="np-detail-collapse__title">
                      <div class="np-detail-collapse__lang">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-gb ">
                            <use :xlink:href="'/images/useful/svg/theme/symbol-defs.svg#icon-' + item.icon"></use>
                          </svg>
                        </div><span class="np-detail-collapse__lang__text">{{item.title}}</span>
                      </div>
                      <button
                        type="button"
                        data-opened="Hide" data-closed="Show"
                        :class="['btn', 'btn--collapse', 'js-collapse-trigger', { 'is-active': item.collapse }]"
                        @click="item.collapse = !item.collapse"
                        >
                        <div class="btn--collapse__icon">
                          <svg width="1em" height="1em" class="icon icon-collapse ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                          </svg>
                        </div>
                      </button>
                    </div>
                    <div class="np-detail-collapse__inner js-collapse-inner">
                      <div class="np-detail-collapse__body">
                        <div class="np-detail-collapse__body__group">
                          <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">Park Name for Client</span>
                              <div class="form-control-wrap">
                                <input type="text" placeholder="Park's name" @input="isEditFlag = true" v-model="item.nameForClient" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-name"/>
                              </div>
                            </div>
                          </div>
						  <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">Park Name for Calculator</span>
                              <div class="form-control-wrap">
                                <input type="text" placeholder="Park's name" @input="isEditFlag = true" v-model="item.nameForSystem" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="np-detail-collapse__body__group">
                          <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">Description</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" v-model="item.desc" @input="isEditFlag = true" :config="editorConfig"></editor>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="np-detail-collapse__body__side">
                            <div class="form-control-group"><span class="form-control-label">Additional Notes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" v-model="item.note" @input="isEditFlag = true" :config="editorConfig2"></editor>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="np-detail-section">
                  <div class="np-detail-section__title"><span>2. Safari program</span></div>
                  <div
                    v-for="(item, index) in safari"
                    :key="item.title"
                    :class="['np-detail-collapse', 'js-collapse', { 'is-collapsed' : item.collapse }]">
                    <div class="np-detail-collapse__title">
                      <div class="np-detail-collapse__lang">
                        <div class="np-detail-collapse__lang__icon">
                          <svg width="1em" height="1em" class="icon icon-gb ">
                            <use :xlink:href="'/images/useful/svg/theme/symbol-defs.svg#icon-' + item.icon"></use>
                          </svg>
                        </div><span class="np-detail-collapse__lang__text">{{item.title}}</span>
                      </div>
                      <button type="button" data-opened="Hide" data-closed="Show"
                        :class="['btn', 'btn--collapse', 'js-collapse-trigger', { 'is-active': item.collapse }]"
                        @click="item.collapse = !item.collapse">
                        <div class="btn--collapse__icon">
                          <svg width="1em" height="1em" class="icon icon-collapse ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-collapse"></use>
                          </svg>
                        </div>
                      </button>
                    </div>
                    <div class="np-detail-collapse__inner js-collapse-inner">
                      <div class="np-detail-collapse__body">
                        <div class="np-detail-collapse__body__day">
                          <div class="np-detail-collapse__body__day__top">
                            <div class="np-detail-collapse__body__day__name"><span>Day 1</span></div>
                          </div>
                          <div class="np-detail-collapse__body__day__content">
                            <div class="form-control-group"><span class="form-control-label">Description</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" @input="isEditFlag = true" v-model="item.desc1" :config="editorConfig"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-group"><span class="form-control-label">Additional Notes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" @input="isEditFlag = true" v-model="item.note1" :config="editorConfig2"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-photo-group form-control-photo-group--squared">
								<input type="file" :id="'photo_load1' + index" class="input-hidden" @change="isEditFlag = true"/>
								<label  class="form-control-photo" v-if="!item.photo1" @click="idPhoto = index;idTypePhoto = 1; $emit('changeImage', 'itinerary')"><span class="form-control-photo__box"></span></label>
								<div class="form-control-photo" v-if="item.photo1"><span class="form-control-photo__box h-object-fit"><img
										:src="`${API}/documents/share/images/${item.photo1}?size=MEDIUM`" alt="photo"></span>
									<button type="button" class="btn btn--remove" @click="item.photo1 = null">
										<svg width="1em" height="1em" class="icon icon-close ">
										<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
										</svg>
									</button>
									</div>
								<div class="form-control-photo-content">
									<div class="form-control-photo-content__line"><span class="form-control-photo-name">Photo</span></div>
									<div class="form-control-photo-content__line">
										<label  class="btn btn--rounded btn-photo-load" @click="idPhoto = index;idTypePhoto = 1; $emit('changeImage', 'itinerary')">{{item.photo1 ? 'Change photo' : 'Add Photo'}}</label>
									</div>
									<div class="form-control-photo-content__line" v-if="!item.photo1"><span class="form-control-photo-content__size">Minimum image size: <b>664 x 280p</b></span><span class="form-control-photo-content__size">Max <b>5 MB</b></span></div>
								</div>
							</div>
                          </div>
                        </div>
                        <div class="np-detail-collapse__body__day">
                          <div class="np-detail-collapse__body__day__top">
                            <div class="np-detail-collapse__body__day__name"><span>Day 2</span></div>
                          </div>
                          <div class="np-detail-collapse__body__day__content">
                            <div class="form-control-group"><span class="form-control-label">Description</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" @input="isEditFlag = true" v-model="item.desc2" :config="editorConfig"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-group"><span class="form-control-label">Additional Notes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" @input="isEditFlag = true" v-model="item.note2" :config="editorConfig2"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-photo-group form-control-photo-group--squared">
								<input type="file" :id="'photo_load2' + index" class="input-hidden" @change="isEditFlag = true"/>
								<label  class="form-control-photo" v-if="!item.photo2" @click="idPhoto = index;idTypePhoto = 2; $emit('changeImage', 'itinerary')"><span class="form-control-photo__box"></span></label>
								<div class="form-control-photo" v-if="item.photo2"><span class="form-control-photo__box h-object-fit"><img
										:src="`${API}/documents/share/images/${item.photo2}?size=MEDIUM`" alt="photo"></span>
									<button type="button" class="btn btn--remove" @click="item.photo2 = null">
										<svg width="1em" height="1em" class="icon icon-close ">
										<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
										</svg>
									</button>
									</div>
								<div class="form-control-photo-content">
									<div class="form-control-photo-content__line"><span class="form-control-photo-name">Photo</span></div>
									<div class="form-control-photo-content__line">
										<label class="btn btn--rounded btn-photo-load" @click="idPhoto = index;idTypePhoto = 2;$emit('changeImage', 'itinerary')">{{item.photo2 ? 'Change photo' : 'Add Photo'}}</label>
									</div>
									<div class="form-control-photo-content__line" v-if="!item.photo2"><span class="form-control-photo-content__size">Minimum image size: <b>664 x 280p</b></span><span class="form-control-photo-content__size">Max <b>5 MB</b></span></div>
								</div>
							</div>
                          </div>
                        </div>
						            <div class="np-detail-collapse__body__day">
                          <div class="np-detail-collapse__body__day__top">
                            <div class="np-detail-collapse__body__day__name"><span>Day 3</span></div>
                          </div>
                          <div class="np-detail-collapse__body__day__content">
                            <div class="form-control-group"><span class="form-control-label">Description</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" @input="isEditFlag = true" v-model="item.desc3" :config="editorConfig"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-group"><span class="form-control-label">Additional Notes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                    <editor :editor="editor" @input="isEditFlag = true" v-model="item.note3" :config="editorConfig2"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-photo-group form-control-photo-group--squared">
								<input type="file" :id="'photo_load2' + index" class="input-hidden" @change="isEditFlag = true"/>
								<label  class="form-control-photo" v-if="!item.photo3" @click="idPhoto = index;idTypePhoto = 3; $emit('changeImage', 'itinerary')"><span class="form-control-photo__box"></span></label>
								<div class="form-control-photo" v-if="item.photo3"><span class="form-control-photo__box h-object-fit"><img
										:src="`${API}/documents/share/images/${item.photo3}?size=MEDIUM`" alt="photo"></span>
									<button type="button" class="btn btn--remove" @click="item.photo3 = null">
										<svg width="1em" height="1em" class="icon icon-close ">
										<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
										</svg>
									</button>
									</div>
								<div class="form-control-photo-content">
									<div class="form-control-photo-content__line"><span class="form-control-photo-name">Photo</span></div>
									<div class="form-control-photo-content__line">
										<label class="btn btn--rounded btn-photo-load" @click="idPhoto = index;idTypePhoto = 3;$emit('changeImage', 'itinerary')">{{item.photo3 ? 'Change photo' : 'Add Photo'}}</label>
									</div>
									<div class="form-control-photo-content__line" v-if="!item.photo3"><span class="form-control-photo-content__size">Minimum image size: <b>664 x 280p</b></span><span class="form-control-photo-content__size">Max <b>5 MB</b></span></div>
								</div>
							</div>
                          </div>
                        </div>
                        <div class="np-detail-collapse__body__day">
                          <div class="np-detail-collapse__body__day__top">
                            <div class="np-detail-collapse__body__day__name"><span>Day 4</span></div>
                          </div>
                          <div class="np-detail-collapse__body__day__content">
                            <div class="form-control-group"><span class="form-control-label">Description</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                  <editor :editor="editor" @input="isEditFlag = true" v-model="item.desc4" :config="editorConfig"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-group"><span class="form-control-label">Additional Notes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                  <editor :editor="editor" @input="isEditFlag = true" v-model="item.note4" :config="editorConfig2"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-photo-group form-control-photo-group--squared">
                              <input type="file" :id="'photo_load2' + index" class="input-hidden" @change="isEditFlag = true"/>
                              <label  class="form-control-photo" v-if="!item.photo4" @click="idPhoto = index;idTypePhoto = 4; $emit('changeImage', 'itinerary')"><span class="form-control-photo__box"></span></label>
                              <div class="form-control-photo" v-if="item.photo4"><span class="form-control-photo__box h-object-fit"><img
                                  :src="`${API}/documents/share/images/${item.photo4}?size=MEDIUM`" alt="photo"></span>
                                <button type="button" class="btn btn--remove" @click="item.photo4 = null">
                                  <svg width="1em" height="1em" class="icon icon-close ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                  </svg>
                                </button>
                              </div>
                              <div class="form-control-photo-content">
                                <div class="form-control-photo-content__line"><span class="form-control-photo-name">Photo</span></div>
                                <div class="form-control-photo-content__line">
                                  <label class="btn btn--rounded btn-photo-load" @click="idPhoto = index;idTypePhoto = 4;$emit('changeImage', 'itinerary')">{{item.photo3 ? 'Change photo' : 'Add Photo'}}</label>
                                </div>
                                <div class="form-control-photo-content__line" v-if="!item.photo4"><span class="form-control-photo-content__size">Minimum image size: <b>664 x 280p</b></span><span class="form-control-photo-content__size">Max <b>5 MB</b></span></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="np-detail-collapse__body__day">
                          <div class="np-detail-collapse__body__day__top">
                            <div class="np-detail-collapse__body__day__name"><span>Day 5</span></div>
                          </div>
                          <div class="np-detail-collapse__body__day__content">
                            <div class="form-control-group"><span class="form-control-label">Description</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                  <editor :editor="editor" @input="isEditFlag = true" v-model="item.desc5" :config="editorConfig"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-group"><span class="form-control-label">Additional Notes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                  <editor :editor="editor" @input="isEditFlag = true" v-model="item.note5" :config="editorConfig2"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-photo-group form-control-photo-group--squared">
                              <input type="file" :id="'photo_load2' + index" class="input-hidden" @change="isEditFlag = true"/>
                              <label  class="form-control-photo" v-if="!item.photo5" @click="idPhoto = index;idTypePhoto = 5; $emit('changeImage', 'itinerary')"><span class="form-control-photo__box"></span></label>
                              <div class="form-control-photo" v-if="item.photo5"><span class="form-control-photo__box h-object-fit"><img
                                  :src="`${API}/documents/share/images/${item.photo5}?size=MEDIUM`" alt="photo"></span>
                                <button type="button" class="btn btn--remove" @click="item.photo5 = null">
                                  <svg width="1em" height="1em" class="icon icon-close ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                  </svg>
                                </button>
                              </div>
                              <div class="form-control-photo-content">
                                <div class="form-control-photo-content__line"><span class="form-control-photo-name">Photo</span></div>
                                <div class="form-control-photo-content__line">
                                  <label class="btn btn--rounded btn-photo-load" @click="idPhoto = index;idTypePhoto = 5;$emit('changeImage', 'itinerary')">{{item.photo3 ? 'Change photo' : 'Add Photo'}}</label>
                                </div>
                                <div class="form-control-photo-content__line" v-if="!item.photo5"><span class="form-control-photo-content__size">Minimum image size: <b>664 x 280p</b></span><span class="form-control-photo-content__size">Max <b>5 MB</b></span></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="np-detail-collapse__body__day">
                          <div class="np-detail-collapse__body__day__top">
                            <div class="np-detail-collapse__body__day__name"><span>Day 6</span></div>
                          </div>
                          <div class="np-detail-collapse__body__day__content">
                            <div class="form-control-group"><span class="form-control-label">Description</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                  <editor :editor="editor" @input="isEditFlag = true" v-model="item.desc6" :config="editorConfig"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-group"><span class="form-control-label">Additional Notes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                  <editor :editor="editor" @input="isEditFlag = true" v-model="item.note6" :config="editorConfig2"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-photo-group form-control-photo-group--squared">
                              <input type="file" :id="'photo_load2' + index" class="input-hidden" @change="isEditFlag = true"/>
                              <label  class="form-control-photo" v-if="!item.photo6" @click="idPhoto = index;idTypePhoto = 6; $emit('changeImage', 'itinerary')"><span class="form-control-photo__box"></span></label>
                              <div class="form-control-photo" v-if="item.photo6"><span class="form-control-photo__box h-object-fit"><img
                                  :src="`${API}/documents/share/images/${item.photo6}?size=MEDIUM`" alt="photo"></span>
                                <button type="button" class="btn btn--remove" @click="item.photo6 = null">
                                  <svg width="1em" height="1em" class="icon icon-close ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                  </svg>
                                </button>
                              </div>
                              <div class="form-control-photo-content">
                                <div class="form-control-photo-content__line"><span class="form-control-photo-name">Photo</span></div>
                                <div class="form-control-photo-content__line">
                                  <label class="btn btn--rounded btn-photo-load" @click="idPhoto = index;idTypePhoto = 6;$emit('changeImage', 'itinerary')">{{item.photo3 ? 'Change photo' : 'Add Photo'}}</label>
                                </div>
                                <div class="form-control-photo-content__line" v-if="!item.photo6"><span class="form-control-photo-content__size">Minimum image size: <b>664 x 280p</b></span><span class="form-control-photo-content__size">Max <b>5 MB</b></span></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="np-detail-collapse__body__day">
                          <div class="np-detail-collapse__body__day__top">
                            <div class="np-detail-collapse__body__day__name"><span>Day 7</span></div>
                          </div>
                          <div class="np-detail-collapse__body__day__content">
                            <div class="form-control-group"><span class="form-control-label">Description</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                  <editor :editor="editor" @input="isEditFlag = true" v-model="item.desc7" :config="editorConfig"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-group"><span class="form-control-label">Additional Notes</span>
                              <div class="form-control-wrap">
                                <div class="js-ckeditor">
                                  <editor :editor="editor" @input="isEditFlag = true" v-model="item.note7" :config="editorConfig2"></editor>
                                </div>
                              </div>
                            </div>
                            <div class="form-control-photo-group form-control-photo-group--squared">
                              <input type="file" :id="'photo_load2' + index" class="input-hidden" @change="isEditFlag = true"/>
                              <label  class="form-control-photo" v-if="!item.photo7" @click="idPhoto = index;idTypePhoto = 7; $emit('changeImage', 'itinerary')"><span class="form-control-photo__box"></span></label>
                              <div class="form-control-photo" v-if="item.photo7"><span class="form-control-photo__box h-object-fit"><img
                                  :src="`${API}/documents/share/images/${item.photo7}?size=MEDIUM`" alt="photo"></span>
                                <button type="button" class="btn btn--remove" @click="item.photo7 = null">
                                  <svg width="1em" height="1em" class="icon icon-close ">
                                    <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                  </svg>
                                </button>
                              </div>
                              <div class="form-control-photo-content">
                                <div class="form-control-photo-content__line"><span class="form-control-photo-name">Photo</span></div>
                                <div class="form-control-photo-content__line">
                                  <label class="btn btn--rounded btn-photo-load" @click="idPhoto = index;idTypePhoto = 7;$emit('changeImage', 'itinerary')">{{item.photo3 ? 'Change photo' : 'Add Photo'}}</label>
                                </div>
                                <div class="form-control-photo-content__line" v-if="!item.photo7"><span class="form-control-photo-content__size">Minimum image size: <b>664 x 280p</b></span><span class="form-control-photo-content__size">Max <b>5 MB</b></span></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="np-detail-section">
                  <div class="np-detail-section__title np-detail-section__title--no-border"><span>3. Age settings</span></div>
                  <div class="age-settings">
                    <div class="age-box">
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>Min Age</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" v-model="age.min" @input="isEditFlag = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                    </div>
                    <div class="age-box">
                      <div class="age-box__icon">
                        <div class="age-box__icon__box">
                          <svg width="1em" height="1em" class="icon icon-child ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-child"></use>
                          </svg>
                        </div><span class="age-box__icon__name">Child</span>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>To</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" v-model="age.child" @input="isEditFlag = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                    </div>
                    <div class="age-box">
                      <div class="age-box__icon">
                        <div class="age-box__icon__box">
                          <svg width="1em" height="1em" class="icon icon-teenager ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-teenager"></use>
                          </svg>
                        </div><span class="age-box__icon__name">Teenager</span>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>From</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" v-model="age.teenFrom" @input="isEditFlag = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>To</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" v-model="age.teenTo" @input="isEditFlag = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control form-control-age"/>
                        </div>
                      </div>
                    </div>
                    <div class="age-box">
                      <div class="age-box__icon">
                        <div class="age-box__icon__box">
                          <svg width="1em" height="1em" class="icon icon-adult ">
                            <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-adult"></use>
                          </svg>
                        </div><span class="age-box__icon__name">Adult</span>
                      </div>
                      <div class="age-box__inner">
                        <div class="age-box__inner__descr"><span>From</span></div>
                        <div class="age-box__inner__input">
                          <input type="number" placeholder="0" v-model="age.adult" @input="isEditFlag = true" @focus="$event.target.parentElement.classList.remove('is-error')" class="form-control  form-control-age"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
			  <ParkPrices @notLeavePopupHandler="data => $emit('notLeavePopupHandler', data)" @deleteModalHandler="data => $emit('deleteModalHandler', data)" :park="park" :user="user" :save="save" @closeSelects="changeSelects" @errored="$emit('errored')"/>
         <div class="np-detail-form__submit">
                  <button type="button" class="btn btn--silver" @click="deleteParkHandler()" v-if="isEdit"> <span>Delete</span></button>
                  <button type="button" class="btn btn--green btn--shadowed" @click="isEdit ? updateParkHandler() : createParkHandler()"><span>{{isEdit ? 'Save' : 'Add'}}</span></button>
                </div>
            </section>
          </div>
        </div>
        </main>
    </div>
</template>

<script>

    import { getSeasonsType, API, uploadUserImage, createPark, getPark, updatePark, deletePark, getCountries } from '@/utilites/api'

    import CKEditor from '@ckeditor/ckeditor5-vue2'
    import ClassicEditor from '@/utilites/ckeditor'

    import SeasonBox from '@/components/SeasonBox'
    import ParkPrices from '@/components/ParkPrices'


    export default {
        components: { editor: CKEditor.component, SeasonBox, ParkPrices },
        props: ['user', 'uploadedFile'],
        data(){
            return {
				API: API,
                editor: ClassicEditor,
                editorConfig: {
                    placeholder: 'Write description'
                },
                editorConfig2: {
                    placeholder: 'Write notes'
                },
				idPhoto: null,
				idTypePhoto: null,
                info: [
                    {
                        title: 'English',
                        icon: 'gb',
                        collapse: true,
                        nameForClient: '',
                        nameForSystem: '',
                        desc: '',
                        note: ''
                    },
                    {
                        title: 'Russian',
                        icon: 'rus',
                        collapse: false,
                        nameForClient: '',
                        nameForSystem: '',
                        desc: '',
                        note: ''
                    },
                ],
                selects: {
                    country: false,
                    territory: false,
                    location: false,
                    area: false,
                    seasons: false
                },
                safari: [
                    {
                        title: 'English',
                        icon: 'gb',
                        collapse: true,
                        desc1: '',
                        note1: '',
                        desc2: '',
                        note2: '',
						            desc3: '',
                        note3: '',
                        desc4: '',
                        note4: '',
                        desc5: '',
                        note5: '',
                        desc6: '',
                        note6: '',
                        desc7: '',
                        note7: '',
						            photo1: null,
						            photo2: null,
						            photo3: null,
                        photo4: null,
                        photo5: null,
                        photo6: null,
                        photo7: null,
                    },
                    {
                        title: 'Russian',
                        icon: 'rus',
                        collapse: false,
                        desc1: '',
                        note1: '',
                        desc2: '',
                        note2: '',
                        desc3: '',
                        note3: '',
                        desc4: '',
                        note4: '',
                        desc5: '',
                        note5: '',
                        desc6: '',
                        note6: '',
                        desc7: '',
                        note7: '',
                        photo1: null,
                        photo2: null,
                        photo3: null,
                        photo4: null,
                        photo5: null,
                        photo6: null,
                        photo7: null,
                    },
                ],
                area: [],
                territoriesAll: [],
                locationsAll: [],
                areasAll: [],
                seasons: [],
                countries: [],
                countryId: null,
                errors: {
                    country: false
                },
				        photo: null,
                age: {
                    min: '',
                    child: '',
                    teenFrom : '',
                    teenTo: '',
                    adult: ''
                },
                data: {

                },
                isEdit: false,
                park: null,
                isLoad: false,
                save: 0,
                isEditFlag: false
            }
        },
		beforeRouteLeave(to, from, next){
			if(this.isEditFlag){
				this.$emit('notLeaveHandler')
			}
			next()
		},
		 beforeCreate(){
           document.title = 'Safari / National Parks / Detail'
        },
        mounted() {
			document.title = 'Safari / National Parks / Detail'
			this.isEdit = this.$route.params.id
			if(this.isEdit){
				getPark(this.user.access_token, this.isEdit)
				.then(res => {
					this.isLoad = true
					this.park = res
					this.countryId = res.country.id
					this.info = [
						{
							title: 'English',
							icon: 'gb',
							collapse: true,
							nameForClient: res.info.EN.nameForClient,
							nameForSystem: res.info.EN.nameForSystem,
							desc: res.info.EN.description,
							note: res.info.EN.additionalNotes
						},
						{
							title: 'Russian',
							icon: 'rus',
							collapse: false,
							nameForClient: res.info.RU.nameForClient,
							nameForSystem: res.info.RU.nameForSystem,
							desc: res.info.RU.description,
							note: res.info.RU.additionalNotes
						},
					]
					this.safari = [
						{
							title: 'English',
							icon: 'gb',
							collapse: true,
							desc1: res.safariProgram.EN[0].description,
							note1: res.safariProgram.EN[0].additionalNotes,
							desc2: res.safariProgram.EN[1].description,
							note2: res.safariProgram.EN[1].additionalNotes,
							desc3: res.safariProgram.EN[2].description,
							note3: res.safariProgram.EN[2].additionalNotes,
              desc4: res.safariProgram.EN[3].description,
              note4: res.safariProgram.EN[3].additionalNotes,
              desc5: res.safariProgram.EN[4].description,
              note5: res.safariProgram.EN[4].additionalNotes,
              desc6: res.safariProgram.EN[5].description,
              note6: res.safariProgram.EN[5].additionalNotes,
              desc7: res.safariProgram.EN[6].description,
              note7: res.safariProgram.EN[6].additionalNotes,
							photo1: res.safariProgram.EN[0].photo,
							photo2: res.safariProgram.EN[1].photo,
							photo3: res.safariProgram.EN[2].photo,
              photo4: res.safariProgram.EN[3].photo,
              photo5: res.safariProgram.EN[4].photo,
              photo6: res.safariProgram.EN[5].photo,
              photo7: res.safariProgram.EN[6].photo,
						},
						{
							title: 'Russian',
							icon: 'rus',
							collapse: false,
              desc1: res.safariProgram.RU[0].description,
              note1: res.safariProgram.RU[0].additionalNotes,
              desc2: res.safariProgram.RU[1].description,
              note2: res.safariProgram.RU[1].additionalNotes,
              desc3: res.safariProgram.RU[2].description,
              note3: res.safariProgram.RU[2].additionalNotes,
              desc4: res.safariProgram.RU[3].description,
              note4: res.safariProgram.RU[3].additionalNotes,
              desc5: res.safariProgram.RU[4].description,
              note5: res.safariProgram.RU[4].additionalNotes,
              desc6: res.safariProgram.RU[5].description,
              note6: res.safariProgram.RU[5].additionalNotes,
              desc7: res.safariProgram.RU[6].description,
              note7: res.safariProgram.RU[6].additionalNotes,
              photo1: res.safariProgram.RU[0].photo,
              photo2: res.safariProgram.RU[1].photo,
              photo3: res.safariProgram.RU[2].photo,
              photo4: res.safariProgram.RU[3].photo,
              photo5: res.safariProgram.RU[4].photo,
              photo6: res.safariProgram.RU[5].photo,
              photo7: res.safariProgram.RU[6].photo,
						},
					]
					this.photo = res.photo,
					this.age = {
						min: res.ageSettings.minAge,
						child: res.ageSettings.child.to,
						teenFrom : res.ageSettings.teenager.from,
						teenTo: res.ageSettings.teenager.to,
						adult: res.ageSettings.adult.from
					}
				})
			} else {
				this.isLoad = true
			}
			getCountries().then(res => {
				this.countries = res.sort((a, b) => a.name.localeCompare(b.name))
			})
            getSeasonsType(this.user.access_token, 'park')
            .then(res => {
                this.seasons = res
            })
            window.addEventListener('click', event => {
                if(!event.target.closest('.select-wrapper')){
                    this.selects = {
                        country: false,
                        territory: false,
                        location: false,
                        area: false,
                        seasons: false
                    }
                }
            })
        },
		methods: {
			changeSelects(target){
				this.selects = {
                    country: false,
                    territory: false,
                    location: false,
                    area: false,
					[target] : !this.selects[target]
				}
			},
			checkError(){
				let error = false
				this.errors.country = !this.countryId
				if(this.errors.country){
					error = true
				}
				document.querySelectorAll('.form-control-name').forEach(elem => {
					if(elem.value.trim().length <= 0){
						elem.parentElement.classList.add('is-error')
						error = true
					}
				})
				document.querySelectorAll('.form-control-age').forEach(elem => {
					if(elem.value.trim().length < 0 || +elem.value <= 0){
						elem.parentElement.classList.add('is-error')
						error = true
					}
				})
				return error
			},
			createParkHandler(){
				if(!this.checkError()){
					createPark(this.user.access_token, {
						"countryId": this.countryId,
						"photo": this.photo,
						"info": {
							"EN": {
								"nameForClient": this.info[0].nameForClient,
								"nameForSystem": this.info[0].nameForSystem,
								"description": this.info[0].desc,
								"additionalNotes": this.info[0].note
							},
							"RU": {
								"nameForClient": this.info[1].nameForClient,
								"nameForSystem": this.info[1].nameForSystem,
								"description": this.info[1].desc,
								"additionalNotes": this.info[1].note
							},
						},
						"safariProgram": {
							"EN": [
								{
									"day": 1,
									"description": this.safari[0].desc1,
									"additionalNotes": this.safari[0].note1,
									"photo": this.safari[0].photo1
								},
								{
									"day": 2,
									"description": this.safari[0].desc2,
									"additionalNotes": this.safari[0].note2,
									"photo": this.safari[0].photo2
								},
								{
									"day": 3,
									"description": this.safari[0].desc3,
									"additionalNotes": this.safari[0].note3,
									"photo": this.safari[0].photo3
								},
                {
                  "day": 4,
                  "description": this.safari[0].desc4,
                  "additionalNotes": this.safari[0].note4,
                  "photo": this.safari[0].photo4
                },
                {
                  "day": 5,
                  "description": this.safari[0].desc5,
                  "additionalNotes": this.safari[0].note5,
                  "photo": this.safari[0].photo5
                },
                {
                  "day": 6,
                  "description": this.safari[0].desc6,
                  "additionalNotes": this.safari[0].note6,
                  "photo": this.safari[0].photo6
                },
                {
                  "day": 7,
                  "description": this.safari[0].desc7,
                  "additionalNotes": this.safari[0].note7,
                  "photo": this.safari[0].photo7
                },
							],
							"RU": [
								{
									"day": 1,
									"description": this.safari[1].desc1,
									"additionalNotes": this.safari[1].note1,
									"photo": this.safari[1].photo1
								},
								{
									"day": 2,
									"description": this.safari[1].desc2,
									"additionalNotes": this.safari[1].note2,
									"photo": this.safari[1].photo2
								},
								{
									"day": 3,
									"description": this.safari[1].desc3,
									"additionalNotes": this.safari[1].note3,
									"photo": this.safari[1].photo3
								},
                {
                  "day": 4,
                  "description": this.safari[1].desc4,
                  "additionalNotes": this.safari[1].note4,
                  "photo": this.safari[1].photo4
                },
                {
                  "day": 5,
                  "description": this.safari[1].desc5,
                  "additionalNotes": this.safari[1].note5,
                  "photo": this.safari[1].photo5
                },
                {
                  "day": 6,
                  "description": this.safari[1].desc6,
                  "additionalNotes": this.safari[1].note6,
                  "photo": this.safari[1].photo6
                },
                {
                  "day": 7,
                  "description": this.safari[1].desc7,
                  "additionalNotes": this.safari[1].note7,
                  "photo": this.safari[1].photo7
                },
							],
						},
						"ageSettings": {
							"minAge": +this.age.min,
							"child": {
								"from": +this.age.min,
								"to": +this.age.child
							},
							"teenager": {
								"from": +this.age.teenFrom,
								"to": +this.age.teenTo
							},
							"adult": {
								"from": +this.age.adult,
								"to": 100
							}
						}
					})
					.then(res => {
						this.save += 1
						this.park = res
						this.$emit('confirmed')
						this.isEditFlag = false
						this.$router.back()
					})
				} else {
					window.scrollTo({
						top: 0
					})
				}
			},
			updateParkHandler(){
				if(!this.checkError()){
					updatePark(this.user.access_token, {
						id: this.park.id,
						"countryId": this.countryId,
						"photo": this.photo,
						"info": {
							"EN": {
								"nameForClient": this.info[0].nameForClient,
								"nameForSystem": this.info[0].nameForSystem,
								"description": this.info[0].desc,
								"additionalNotes": this.info[0].note
							},
							"RU": {
								"nameForClient": this.info[1].nameForClient,
								"nameForSystem": this.info[1].nameForSystem,
								"description": this.info[1].desc,
								"additionalNotes": this.info[1].note
							},
						},
						"safariProgram": {
							"EN": [
								{
									"day": 1,
									"description": this.safari[0].desc1,
									"additionalNotes": this.safari[0].note1,
									"photo": this.safari[0].photo1
								},
								{
									"day": 2,
									"description": this.safari[0].desc2,
									"additionalNotes": this.safari[0].note2,
									"photo": this.safari[0].photo2
								},
								{
									"day": 3,
									"description": this.safari[0].desc3,
									"additionalNotes": this.safari[0].note3,
									"photo": this.safari[0].photo3
								},
                {
                  "day": 4,
                  "description": this.safari[0].desc4,
                  "additionalNotes": this.safari[0].note4,
                  "photo": this.safari[0].photo4
                },
                {
                  "day": 5,
                  "description": this.safari[0].desc5,
                  "additionalNotes": this.safari[0].note5,
                  "photo": this.safari[0].photo5
                },
                {
                  "day": 6,
                  "description": this.safari[0].desc6,
                  "additionalNotes": this.safari[0].note6,
                  "photo": this.safari[0].photo6
                },
                {
                  "day": 7,
                  "description": this.safari[0].desc7,
                  "additionalNotes": this.safari[0].note7,
                  "photo": this.safari[0].photo7
                },
							],
							"RU": [
								{
									"day": 1,
									"description": this.safari[1].desc1,
									"additionalNotes": this.safari[1].note1,
									"photo": this.safari[1].photo1
								},
								{
									"day": 2,
									"description": this.safari[1].desc2,
									"additionalNotes": this.safari[1].note2,
									"photo": this.safari[1].photo2
								},
								{
									"day": 3,
									"description": this.safari[1].desc3,
									"additionalNotes": this.safari[1].note3,
									"photo": this.safari[1].photo3
								},
                {
                  "day": 4,
                  "description": this.safari[1].desc4,
                  "additionalNotes": this.safari[1].note4,
                  "photo": this.safari[1].photo4
                },
                {
                  "day": 5,
                  "description": this.safari[1].desc5,
                  "additionalNotes": this.safari[1].note5,
                  "photo": this.safari[1].photo5
                },
                {
                  "day": 6,
                  "description": this.safari[1].desc6,
                  "additionalNotes": this.safari[1].note6,
                  "photo": this.safari[1].photo6
                },
                {
                  "day": 7,
                  "description": this.safari[1].desc7,
                  "additionalNotes": this.safari[1].note7,
                  "photo": this.safari[1].photo7
                },
							],
						},
						"ageSettings": {
							"minAge": +this.age.min,
							"child": {
								"from": +this.age.min,
								"to": +this.age.child
							},
							"teenager": {
								"from": +this.age.teenFrom,
								"to": +this.age.teenTo
							},
							"adult": {
								"from": +this.age.adult,
								"to": 100
							}
						}
					})
       				.then(() => {
						   this.save += 1
						   this.$emit('confirmed')
						   this.isEditFlag = false
						   this.$router.back()
					   })
				} else {
					window.scrollTo({
						top: 0
					})
				}
			},
			deleteParkHandler(){
				deletePark(this.user.access_token, this.park.id)
				.then(res => {
					this.$router.back()
         			this.$emit('confirmed')
				})
			}
		},
		watch: {
			uploadedFile(){
				if(this.uploadedFile){
					this.safari = this.safari.map((item, index) => {
						if(this.idPhoto === index){
							return {
								...item,
								['photo' + this.idTypePhoto]: this.uploadedFile
							}
						}
						return item
					})
				}
			}
		}
    }
</script>

<style scoped lang="scss">
.np-detail-country {
    width: calc(50% - 2rem);
    margin-bottom: 2.2rem;

    .select-wrapper,
    .select-trigger {
        width: 100%;
    }
}

@media (max-width: 991px) {
    .np-detail-country {
        width: calc(50% - 1rem);
    }
}

@media (max-width: 767px) {
    .np-detail-country {
        width: 100%;
    }
}
</style>
